import React from 'react';
import {postFormData} from "../service/fetcher";

export default class Upload extends React.Component {
    constructor(props) {
        super(props);
        this.fileSelect = this.fileSelect.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
    }


    state = {
        selectedFile: undefined, uploaded: 0, uploading: false
    };

    fileSelect = event => this.setState({selectedFile: event.target.files});

    fileUpload = () => this.setState({uploading: true}, async () => {
        for (const selectedFileElement of this.state.selectedFile) {
            let fd = new FormData();
            fd.append('id', this.props.id);
            fd.append('file', selectedFileElement);
            await postFormData("/api/Image", fd, this.props.token)[0];
            this.setState({uploaded: (this.state.uploaded + 1)});
        }
    });

    render() {
        return (
            <div>
                {!this.state.uploading && <div>
                    <input type="file" onChange={this.fileSelect} multiple={true}/>
                    <button onClick={this.fileUpload}
                            disabled={this.state.selectedFile === undefined || (this.state.selectedFile.length === 0)}>Upload
                    </button>
                </div>}
                {this.state.uploading && <div>
                    <p>{this.state.uploaded} geupload van de {this.state.selectedFile.length}</p>
                    {this.state.selectedFile.length === this.state.uploaded &&
                        <button onClick={() => this.props.page("folder", this.props.id)}>Ga terug</button>}
                </div>}
            </div>
        );
    }
}
